/**
 * Asynchronously loads the component for BuyCourse page
 */

import { lazyLoad } from "utils/loadable";

export const BuyCourse = lazyLoad(
  () => import("./index"),
  (module) => module.BuyCourse
);